import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import HeaderProfile from './HeaderProfile';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Proptypes from 'prop-types';

const Header = ({
  onToggle,
  setViewProfile,
  isSidebarCollapsedDesktop,
  isMobile,
}) => {
  const classes = useStyles();

  return (
    <AppBar position="absolute" className={classes.header}>
      <Toolbar className={classes.toolbar}>
        <div onClick={onToggle} className={classes.menuButton}>
          {isSidebarCollapsedDesktop || isMobile ? (
            <ArrowRightIcon
              classes={{ root: classes.mySvgStyle }}
              fontSize="large"
            />
          ) : (
            <ArrowLeftIcon
              fontSize="large"
              classes={{ root: classes.mySvgStyle }}
            />
          )}
        </div>

        <div className={classes.actions}>
          <HeaderProfile setViewProfile={setViewProfile} />
        </div>
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles(theme => ({
  header: {
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: 'none',
  },
  toolbar: {},
  menuButton: {
    // transform: 'rotate(-180deg)',
    height: '2rem',
    width: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    borderRadius: '25%',
  },
  actions: {
    marginLeft: 'auto',
    alignItems: 'center',
    display: 'flex',
  },
  notificationsButton: {
    marginRight: 23,
  },
  title: {
    flexGrow: 1,
  },
  mySvgStyle: {
    cursor: 'pointer',
    '& [id="Layer_1"]': {
      color: `${theme.palette.secondary.light} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.secondary.light} !important`,
      },
    },
  },
}));

Header.propTypes = {
  onToggle: Proptypes.func,
  setViewProfile: Proptypes.func,
  isSidebarCollapsedDesktop: Proptypes.bool,
  isMobile: Proptypes.bool,
};
export default Header;
